import * as React from "react";
import { useCallback, useImperativeHandle, useMemo, useState } from "react";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
import SetStatusBulk from "security-app/components/SecurityEvents/Alerts/AlertsModals/SetStatusModal/SetStatusBulk";
export const BulkSetStatusModal = React.forwardRef(({ events }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const eventIds = useMemo(() => events.map((event) => event.id), [events]);
  const onClose = useCallback(() => setShowModal(false), []);
  useImperativeHandle(ref, () => ({
    toggle: () => setShowModal(true)
  }));
  return /* @__PURE__ */ React.createElement(SetStatusBulk, { eventIds, onClose, show: showModal });
});
export const BulkSetStatusAction = ({ modalRef, onEventCallback }) => {
  const onClick = useCallback(() => {
    if (typeof onEventCallback === "function") {
      onEventCallback();
    }
    return modalRef().toggle();
  }, [modalRef, onEventCallback]);
  return /* @__PURE__ */ React.createElement(MenuItem, { onClick }, "Set Status");
};
